import styled, { css } from 'styled-components';

export const ChevronSvg = styled.svg<{ $isActive: boolean }>`
  transition: transform 250ms ease;
  transform: ${(p) => (p.$isActive ? 'rotate(0deg)' : 'rotate(180deg)')};
`;

export const NavStyle = css`
  display: flex;
  flex-direction: row;
  padding: 0.75rem;
  cursor: pointer;
`;

export const NavContent = styled.span`
  display: flex;
  align-items: center;
  position: relative;

  /* aligns the nav link underline correctly */
  line-height: 1.2;

  /* TODO: wait for MDS to update primaryFontNew to include quotes */
  font-family: 'Basis Grt', sans-serif;

  /* deviates from figma values, but approved by design */
  font-size: ${(p) => p.theme.size['3']}px; /* 16px */
  font-weight: ${(p) => p.theme.fontWeight.primary.medium}; /* 500 */

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -0.25rem;
    height: 2px;
    width: 0;
    background-color: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};
    /* Only animate if user does not prefer reduced motion */
    @media (prefers-reduced-motion: no-preference) {
      /* material design cubic-bezier value*/
      transition: width 0.2s cubic-bezier(0.2, 0, 0, 1);
    }
  }

  &[data-state='open'] {
    color: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};
    ${ChevronSvg} {
      fill: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};
    }
    &::after {
      width: 100%;
    }
  }

  &[data-state='closed'] {
    color: ${(p) => p.theme.midwestColors.black};
    &::after {
      width: 0;
    }
  }

  &:active,
  &:hover,
  &:focus {
    color: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};
    ${ChevronSvg} {
      fill: ${(p) => p.theme.midwestColors.sentimentNegativeStrong};
    }
    &::after {
      width: 100%;
    }
  }
`;
